import { Language } from '../types/language-types';

export const SUPPORTED_LANGUAGES: Language[] = ['hi', 'mr', 'gu', 'ta', 'te', 'kn', 'bn'];
export const DEFAULT_LANGUAGE: Language = 'en';

export const isSupportedLanguage = (lang: string): lang is Language => {
  return SUPPORTED_LANGUAGES.includes(lang as Language);
};
